import type { DecorationWidgetConfig } from '../../types'

export const widgetConfig: DecorationWidgetConfig = {
  type: 'member-card',
  name: '会员卡片',
  icon: '会',
  group: '商城组件',
  description: '会员中心入口、积分说明和权益提示',
  defaultProps: {
    title: '会员中心',
    subtitle: '登录领积分，权益持续累计',
    pointsText: '登录送 10 积分',
    link: '/pages/my/index'
  }
}
